import React, { useEffect, useState } from "react";
import "./ExportMembers.scss";
import Headernav from "../header_nav/Headernav";
import axios from "axios";
import { API_BASE } from "../apiBase";

const statusOptions = [
  { value: "all", label: "All" },
  { value: "alive", label: "Alive" },
  { value: "expired", label: "Expired" },
  { value: "removed", label: "Removed" },
];

const normalizeValue = (value) => {
  if (value === null || value === undefined) {
    return "";
  }
  const trimmed = String(value).trim();
  if (trimmed.toLowerCase() === "null") {
    return "";
  }
  return trimmed;
};

const buildAddress = (row) => {
  const parts = [
    normalizeValue(row.door_no),
    normalizeValue(row.street),
    normalizeValue(row.area),
    normalizeValue(row.city),
    normalizeValue(row.pincode),
  ].filter(Boolean);
  return parts.join(", ");
};

const escapeCsv = (value) => {
  const text = normalizeValue(value);
  if (text === "") {
    return "";
  }
  if (/[",\n]/.test(text)) {
    return `"${text.replace(/"/g, '""')}"`;
  }
  return text;
};

const ExportMembers = () => {
  const [cities, setCities] = useState([]);
  const [selectedCity, setSelectedCity] = useState("all");
  const [status, setStatus] = useState("all");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    axios
      .get(`${API_BASE}/78htc6w4_Get_sudyvgew7_City9879.php`)
      .then((response) => {
        const list = Array.isArray(response.data) ? response.data : [];
        const cleaned = list
          .map((city) => normalizeValue(city))
          .filter((city) => city !== "");
        setCities(cleaned);
      })
      .catch(() => setCities([]));
  }, []);

  const downloadExcel = async () => {
    setLoading(true);
    setMessage("");
    try {
      const params = new URLSearchParams();
      if (selectedCity && selectedCity !== "all") {
        params.append("city", selectedCity);
      }
      if (status && status !== "all") {
        params.append("status", status);
      }

      const url = `${API_BASE}/members_export.php?${params.toString()}`;
      const response = await axios.get(url);
      const rows = Array.isArray(response.data) ? response.data : [];

      if (!rows.length) {
        setMessage("No data found for the selected filters.");
        setLoading(false);
        return;
      }

      const headers = [
        "Member No",
        "Member Name",
        "Father Name",
        "Gender",
        "Blood Group",
        "DOB",
        "Age",
        "Aadhar",
        "Joined Date",
        "Status",
        "Mobile",
        "Whatsapp",
        "Alternative Mobile",
        "Email",
        "Address",
        "Nationality",
        "State",
        "District",
        "Position",
        "Occupation",
        "Father Member No",
        "Head/Child",
        "Description",
      ];

      const bodyRows = rows.map((row) => [
        normalizeValue(row.member_no),
        normalizeValue(row.member_name),
        normalizeValue(row.father_name),
        normalizeValue(row.member_gender),
        normalizeValue(row.member_blood_group),
        normalizeValue(row.member_dob),
        normalizeValue(row.member_age),
        normalizeValue(row.member_aadhar),
        normalizeValue(row.member_joined_date),
        normalizeValue(row.member_current_status),
        normalizeValue(row.member_mobile),
        normalizeValue(row.member_whatsapp),
        normalizeValue(row.member_alternative_mobile),
        normalizeValue(row.member_mail),
        buildAddress(row),
        normalizeValue(row.nationality),
        normalizeValue(row.state),
        normalizeValue(row.district),
        normalizeValue(row.position),
        normalizeValue(row.occupation),
        normalizeValue(row.fathers_member_no),
        normalizeValue(row.head_or_child),
        normalizeValue(row.description),
      ]);

      const csvRows = [
        headers.map(escapeCsv).join(","),
        ...bodyRows.map((row) => row.map(escapeCsv).join(",")),
      ];
      const csvContent = `\ufeff${csvRows.join("\n")}`;

      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      const datePart = new Date().toISOString().slice(0, 10);
      link.href = URL.createObjectURL(blob);
      link.download = `members_export_${datePart}.csv`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
    } catch (error) {
      setMessage("Export failed. Please try again.");
    }
    setLoading(false);
  };

  return (
    <>
      <Headernav />
      <div className="export-members-page">
        <div className="export-card">
          <h2>Export Members</h2>
          <div className="export-filters">
            <div className="filter-field">
              <label>City</label>
              <select value={selectedCity} onChange={(e) => setSelectedCity(e.target.value)}>
                <option value="all">All</option>
                {cities.map((city) => (
                  <option key={city} value={city}>
                    {city}
                  </option>
                ))}
              </select>
            </div>
            <div className="filter-field">
              <label>Status</label>
              <select value={status} onChange={(e) => setStatus(e.target.value)}>
                {statusOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>
            <button type="button" className="export-button" onClick={downloadExcel} disabled={loading}>
              {loading ? "Exporting..." : "Export Excel"}
            </button>
          </div>
          <div className="export-note">Address format: door_no, street, area, city, pincode</div>
          {message && <div className="export-message">{message}</div>}
        </div>
      </div>
    </>
  );
};

export default ExportMembers;
